import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "../../../util/asyncComponent";

const Form = ({ match }) => (
  <Switch>
    <Redirect exact from={`${match.url}/`} to={`${match.url}/videos`} />

    <Route
      path={`${match.url}/detail/:id`}
      component={asyncComponent(() => import("./routes/video-detail"))}
    />

    <Route
      path={`${match.url}/serie/:videoId/:serieId`}
      component={asyncComponent(() => import("./routes/videoserie-detail"))}
    />

    <Route
      path={`${match.url}/cursos`}
      component={asyncComponent(() => import("./routes/cursos"))}
    />

    <Route
      path={`${match.url}/videoblogs`}
      component={asyncComponent(() => import("./routes/videoblogs"))}
    />

    <Route
      component={asyncComponent(() =>
        import("app/routes/extraPages/routes/404")
      )}
    />
  </Switch>
);

export default Form;



// WEBPACK FOOTER //
// ./app/routes/videos/index.js